import React from 'react';

export const TermsPt: React.FC = () => (
  <>
    <section>
      <h2>1. Quem somos e o que estes termos regulam</h2>
      <p>
        A plataforma Roadbase, acessível em roadbase.eu, é explorada por Leonardo Ferreira, pessoa
        singular, NIF 305516760, com domicílio em Praça Nove de Abril, 123, 4200-422 Porto,
        Portugal.
      </p>
      <p>
        Estes termos regulam o acesso e a utilização da plataforma. Ao criar uma conta ou submeter
        um pedido de cotação, aceita ficar vinculado a eles. Se não concordar, não utilize o
        serviço.
      </p>
      <p>
        A plataforma destina-se exclusivamente a profissionais e empresas. Não se destina a
        consumidores nem a menores de 18 anos.
      </p>
    </section>

    <section>
      <h2>2. O que a Roadbase é — e o que não é</h2>
      <p>
        A Roadbase é uma plataforma de intermediação de pedidos de cotação para transporte
        rodoviário de cargas fora de gabarito (OOG) e especiais. Recebemos o seu pedido, contactamos
        transportadoras da nossa rede e apresentamos-lhe as respostas de forma comparável.
      </p>
      <p>Esta cláusula é essencial e prevalece sobre qualquer entendimento em contrário:</p>
      <blockquote>
        <p>
          A Roadbase não é transportadora, não é transitário e não é agente de nenhuma das partes.
          Não executa, não organiza nem supervisiona transportes. Não é parte no contrato de
          transporte, não assume a posição de expedidor nem de transportador, e não presta garantia
          quanto à execução, prazo, integridade da carga ou conformidade regulamentar de qualquer
          transporte.
        </p>
        <p>
          O contrato de transporte é celebrado direta e exclusivamente entre o cliente e a
          transportadora, e rege-se pelas condições acordadas entre ambos e pela Convenção CMR,
          quando aplicável.
        </p>
      </blockquote>
    </section>

    <section>
      <h2>3. Natureza das cotações</h2>
      <p>
        As cotações apresentadas na plataforma são indicativas. Correspondem a informação
        transmitida pelas transportadoras com base nos dados que o cliente forneceu, e não
        constituem proposta contratual vinculativa da Roadbase.
      </p>
      <p>
        O preço final, o prazo, as condições de responsabilidade, os seguros, as autorizações de
        transporte excecional e os custos de escolta ficam sujeitos à confirmação da transportadora
        e às suas condições gerais. Alterações às características da carga, à rota ou às datas podem
        alterar o preço.
      </p>
      <p>
        A Roadbase não verifica de forma independente a exatidão das cotações, a idoneidade das
        transportadoras, a validade das suas licenças ou a cobertura dos seus seguros. Recomendamos
        que o cliente proceda às verificações que a sua própria diligência exija antes de
        contratar.
      </p>
    </section>

    <section>
      <h2>4. Contas</h2>
      <p>
        Para acompanhar os seus pedidos, o cliente cria uma conta associada a um endereço de email.
        É responsável pela veracidade dos dados que fornece, pela confidencialidade das suas
        credenciais e por toda a atividade realizada através da sua conta. Deve comunicar-nos de
        imediato qualquer utilização não autorizada.
      </p>
      <p>
        Podemos suspender ou encerrar contas que violem estes termos, que apresentem dados
        manifestamente falsos ou que sejam usadas de forma que prejudique o serviço ou terceiros.
      </p>
    </section>

    <section>
      <h2>5. Obrigações do cliente quanto aos dados da carga</h2>
      <p>Esta cláusula tem relevância operacional acrescida no transporte OOG.</p>
      <p>
        O cliente obriga-se a fornecer, com exatidão, as dimensões, o peso, a natureza e as
        condições de manuseamento da carga, bem como a indicar se a carga é classificada como
        mercadoria perigosa (ADR) ou se exige condições especiais.
      </p>
      <p>
        Dados incorretos podem determinar a recusa da carga no carregamento, a invalidação de
        autorizações de transporte excecional, a inadequação do equipamento afeto, custos
        adicionais, atrasos e riscos de segurança. A responsabilidade por dados incorretos ou
        incompletos é exclusivamente do cliente, incluindo perante a transportadora.
      </p>
    </section>

    <section>
      <h2>6. Preço</h2>
      <p>
        Durante o período de beta, a utilização da plataforma é gratuita. Comunicaremos com
        antecedência razoável, e nunca inferior a 30 dias, qualquer passagem a modelo pago, ficando
        o cliente livre de não aderir e de encerrar a conta.
      </p>
    </section>

    <section>
      <h2>7. Utilização aceitável</h2>
      <p>O cliente obriga-se a não:</p>
      <ul>
        <li>
          extrair, copiar, reproduzir ou reutilizar, por qualquer meio, o diretório de
          transportadoras da Roadbase ou qualquer parte substancial dele, incluindo por recolha
          automatizada (scraping), sendo esta base protegida ao abrigo do regime jurídico das bases
          de dados;
        </li>
        <li>
          submeter pedidos fictícios, duplicados em massa ou destinados a sondar a rede de
          transportadoras sem intenção real de contratar;
        </li>
        <li>
          carregar ficheiros que contenham código malicioso, ou conteúdos sobre os quais não detenha
          direitos;
        </li>
        <li>aceder ou tentar aceder a áreas, contas ou dados que não lhe pertençam;</li>
        <li>
          utilizar a plataforma para fins ilícitos ou em violação de sanções, embargos ou legislação
          de controlo de exportações aplicável.
        </li>
      </ul>
    </section>

    <section>
      <h2>8. Propriedade intelectual</h2>
      <p>
        A plataforma, o seu código, interface, textos, marca e o diretório de transportadoras são
        propriedade de Leonardo Ferreira ou por si licenciados. O acesso ao serviço não confere
        qualquer licença sobre estes elementos, para além da estritamente necessária à sua
        utilização normal.
      </p>
      <p>
        Os dados que o cliente submete continuam a pertencer-lhe. Concede-nos apenas a licença
        necessária para os tratarmos com o fim de prestar o serviço.
      </p>
    </section>

    <section>
      <h2>9. Disponibilidade</h2>
      <p>
        Procuramos manter a plataforma disponível de forma contínua, mas não garantimos ausência de
        interrupções. Podem ocorrer paragens para manutenção, atualização ou correção de falhas.
        Durante o período de beta não existe qualquer compromisso de nível de serviço (SLA), e
        funcionalidades podem ser alteradas ou removidas.
      </p>
    </section>

    <section>
      <h2>10. Limitação de responsabilidade</h2>
      <p>Na medida máxima permitida pela lei aplicável, a Roadbase não responde por:</p>
      <ul>
        <li>
          atos, omissões, incumprimentos, atrasos, danos ou perdas imputáveis às transportadoras ou
          a qualquer terceiro;
        </li>
        <li>danos na carga, atrasos na entrega, custos de imobilização, coimas ou perdas decorrentes do transporte;</li>
        <li>decisões comerciais tomadas pelo cliente com base em cotações indicativas;</li>
        <li>lucros cessantes, perda de oportunidade, danos indiretos ou consequenciais;</li>
        <li>
          indisponibilidade temporária da plataforma ou perda de dados não imputável a dolo ou
          negligência grosseira nossa.
        </li>
      </ul>
      <p>
        Nada nestes termos exclui a responsabilidade que a lei não permita excluir, designadamente
        por dolo ou por danos causados à vida e à integridade física.
      </p>
    </section>

    <section>
      <h2>11. Dados pessoais</h2>
      <p>
        O tratamento de dados pessoais rege-se pela nossa{' '}
        <a href="/pt/privacidade">Política de Privacidade</a>, que faz parte integrante destes
        termos.
      </p>
    </section>

    <section>
      <h2>12. Duração e cessação</h2>
      <p>
        O cliente pode encerrar a sua conta a qualquer momento, escrevendo para{' '}
        <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>. Podemos cessar a prestação do
        serviço, no todo ou em parte, mediante aviso prévio razoável, salvo em caso de violação
        destes termos, em que a cessação pode ser imediata.
      </p>
      <p>
        A cessação não afeta os direitos e obrigações constituídos até essa data, nem os pedidos e
        contratos de transporte já em curso entre o cliente e as transportadoras.
      </p>
    </section>

    <section>
      <h2>13. Alterações aos termos</h2>
      <p>
        Podemos alterar estes termos. Alterações com impacto material são comunicadas por email com
        pelo menos 15 dias de antecedência. A utilização da plataforma após a entrada em vigor vale
        como aceitação.
      </p>
    </section>

    <section>
      <h2>14. Lei aplicável e foro</h2>
      <p>
        Estes termos regem-se pela lei portuguesa. Para a resolução de qualquer litígio é competente
        o foro da comarca do Porto, com expressa renúncia a qualquer outro.
      </p>
    </section>

    <section>
      <h2>15. Contacto</h2>
      <p>
        <strong>Leonardo Ferreira</strong> — <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>
      </p>
    </section>
  </>
);
